export class PMOProjectSearchDataModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class PMOProject extends PMOProjectSearchDataModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
